/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsScatterAxis: {
  name: 'scatter-axis';
  data: string;
} = {
  name: 'scatter-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-1-.5a.5.5 0 0 0-1 0v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 0-1H1.5V3Zm8 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-8.5 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
